// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import {
  makeSetReducer,
} from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";
import { SOLICITUD_ALTERNATIVAS_API } from "../views/MainLayout/components/shared/services/solicitudAlternativas";

export const solicitudAlternativasFullfilledReducer = makeSetReducer([
  "solicitud_alternativas/fullfilled",
]);

export const fetchSolicitudAlternativas = () => async (dispatch) => {
  try {
    const raw = localStorage.getItem('read_only');
    const readOnly = raw ? JSON.parse(raw) : {};

    const fromCache =
      Array.isArray(readOnly.solicitud_alternativas) &&
      readOnly.solicitud_alternativas.length > 0
        ? readOnly.solicitud_alternativas
        : Array.isArray(readOnly.solucitud_alternativas) &&
            readOnly.solucitud_alternativas.length > 0
          ? readOnly.solucitud_alternativas
          : null;

    if (fromCache) {
      dispatch({
        type: "solicitud_alternativas/fullfilled",
        payload: fromCache,
      });
      return;
    }

    const response = await SOLICITUD_ALTERNATIVAS_API.getStates();
    const data = Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

    dispatch({ type: "solicitud_alternativas/fullfilled", payload: data });

    const nextReadOnly = { ...readOnly, solicitud_alternativas: data };
    localStorage.setItem("read_only", JSON.stringify(nextReadOnly));
  } catch (e) {
    toast.error(setErrorMessage(e))
  } finally {
    dispatch({ type: 'loading/set', payload: false })
  }
};
